<template>
	<div class="ReTicketsLentaNest"  >

		<div class="d-flex justify-content-center " > <h3>ЛЕНТА СООБЩЕНИЙ</h3> </div>
			
		<div class="col px-0">
			<card class="postForm mb-4" :class="{'focus-shadow' : !bIsPostForm}" v-if="status != 'solved' && status !='closed'">
				
				<div class="postForClick" @click="showPostForm()">
					<h5><i class="tim-icons icon-send text-success mr-3"></i>Написать</h5>
				</div>
				<div v-if="!bIsPostForm" class="cancel-note-btn">
					<base-button  @click="cancelForm()" type="danger" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<div class="postAddForm" :class="[bIsPostForm ? 'postAddForm-hide' : 'postAddForm-show']">		
					<form class="form-container">
						<div class="top_part">           
							<textarea 
							class="form-control"
							placeholder="Текст"
							ref="saveInput"						
							v-model="strNote"
							@paste="handlePaste">	
							</textarea>	
						</div>
						<div class="bottom_part mt-2 pb-1">
							<template v-if="fileUpload_model==''">
								<div class="upload-file"> 
									<!--h5>Прикрепить документ:</h5-->
									<ReFileUpload 
										findId="LentaFileUpload"
										v-model="fileUpload_model"
										type="file"
										:multiple="false"
										
										acceptMime="*/*"
										:bShowTrash="false"
										v-on:change="OnUploadFile"
									/>
								</div>
							</template>
							<template v-else>
								<h5 class="upload-file">
									<a :href="fileUpload_model.fullpath" target="_blank">Посмотреть документ</a>
									<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
										<i class="tim-icons icon-trash-simple"></i>
									</button>
								</h5>
							</template>
							
							<base-button v-if="strNote!='' || fileUpload_model!=''" type="success" simple icon @click="SendNote()" class="mr-0">
							<i class="d-inline-block tim-icons icon-send"></i>
							</base-button>		
															
						</div>


					</form>						

				</div>
			</card>
		</div>

		<!-- <pre>{{masLenta.anal}}</pre>  -->
		<!-- <div class="col-12 col-xl-6 px-0"> -->
		<div class="col px-0">
			<div v-for="(anal,a_index) in masLenta.anal" :key="anal.id" class="lenta-item" :class="[{'last':a_index==(masLenta.anal.length-1)}]"> 
				<ReClientNote 
					v-if="anal.note_id !='' && anal.note_id != 0 && !$GVO.isEmpty(getNotes(anal.note_id))" 
					:objNote="getNotes(anal.note_id)" 
					:chatStyle="(anal.agent_id == author_id) ? 'StylesAuthor' : 'StylesRandom'"  
					@onUpdate="getLenta()"
				/>

			</div>
		

		<div class="pagination" v-if="bShowPaginBtn"><base-button @click="pClick()" class="mx-auto" type="success" simple>Загрузить ещё</base-button></div>	
		
		</div>
		<!-- <pre v-if="type=='cc'">{{masLenta}}</pre> -->

	</div>
</template>

<script>

import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReClientNote from "src/our_components/Lenta/ReClientNote.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
import moment from 'moment';
import VueMoment from 'vue-moment';

export default {
	name: 'ReTicketsLentaNest',
	components: {
		ReFileUpload,
		ReClientNote,


	},
	props: {
		ticket_id: [String,Number],	
		author_id: [String,Number],
		status: String,
		// objTicket: Object,
		type:{
			type: String,
			default: 'ticket',
		},
	},
	data () {
		return {
			ver: 1,
			bIsLoading:false,
			masLenta:[],
			bIsPostForm: true,	
			strNote: '',			
			fileUpload_model: '',
			p:1,
			bShowPaginBtn: false,
		}
	},
	computed: {

	},
	methods: {
		pClick(){
			this.p++;
			this.getLenta(false,true);
		},
		getLenta(bEmited=false,bChangePage=false){
			// console.log('this is getLenta in tickets nest');
			if(!bChangePage) this.p = 1;
			this.bIsLoading = true;
			let strMethod = 'TicketSystem.GET_LENTA';
			let obj_id = {obj_id:this.ticket_id};

			this.$GVO.ApiCall(strMethod,{flt:{...obj_id,'p':this.p}})
				.then((objApi) => { 
					this.bIsLoading = false;
					// console.log('getLenta',objApi);
					if(objApi.success === true){
						if(typeof objApi.data.anal != 'undefined' && objApi.data.anal.length < 10) this.bShowPaginBtn = false; else this.bShowPaginBtn = true;
						if(!bChangePage){
							this.masLenta = this.$GVO.unlinkObject(objApi.data);
							// if(this.masLenta.note && Object.keys(this.masLenta.note).length == 1 && ){
							// 	//меняем статус на В работе, если кто-то написал в ленту хотя бы 1 сообещние // важно: кто-то должен быть автором тикета
							// 	console.log('this.masLenta.note ', Object.keys(this.masLenta.note).length);	
							// 	this.SET_STATUS('open');	

							// }else {console.log('this.masLenta.note.length > 1')}
							
						}else{
							this.masLenta.anal = this.masLenta.anal.concat(this.$GVO.unlinkObject(objApi.data).anal);
							// this.masLenta.call = this.masLenta.call.concat(this.$GVO.unlinkObject(objApi.data).call);
							this.masLenta.note = this.masLenta.note.concat(this.$GVO.unlinkObject(objApi.data).note);
							// this.masLenta.cc = this.masLenta.cc.concat(this.$GVO.unlinkObject(objApi.data).cc);
							
							
						}
						
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
							
		
			},


		getNotes(note_id){
			if(typeof this.masLenta.note != 'undefined'){ //console.log(this.masLenta.note);
				if(typeof this.masLenta.note[note_id] != 'undefined'){ 					
					return this.masLenta.note[note_id];
				}
			}
			return {};
		},	

		SendNote() {
			let now = moment().format("YYYY-MM-DD HH:mm:ss");
			
			this.$GVO.ApiCall('NOTES.INS',{
				iData:{
					'obj_type_name': this.type,
					'obj_id':this.ticket_id,
					'title':'Заметка',
					'descr':this.strNote,
					'UpdTime': now,
					'atach_arr': this.fileUpload_model,	
				}
			}).then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masLenta = objApi.data;
					}
					this.getLenta();	
					if(this.status !='open') {
						this.SET_STATUS('open'); // открываем тикет В работе, если мы отправили сообщение, так просила Таня. Если кому-то надо оставить статус В ожидании, то выставляем его сами руками
					}
						
				} 	
				this.bIsPostForm = !this.bIsPostForm;
				this.fileUpload_model = '';
				this.strNote = ''; 
					
			}).catch(errorObjApi => console.error(errorObjApi));			
		},		
		showPostForm() {
			this.bIsPostForm = !this.bIsPostForm;
			this.$nextTick(() => {
				this.$refs.saveInput.focus();
			});

		},
		DoDel(){			
			this.fileUpload_model = '';
		},
		handlePaste(event) {
			// Проверяем, есть ли данные в буфере обмена
			const clipboardItems = event.clipboardData.items
			
			// Ищем изображение в буфере
			let imageFile = null
			
			for (let i = 0; i < clipboardItems.length; i++) {
				const item = clipboardItems[i]
				
				// Проверяем, является ли элемент изображением
				if (item.type.indexOf('image') === 0) {
					imageFile = item.getAsFile()
					break
				}
			}
			
			if (!imageFile) {
				//console.log('В буфере обмена нет изображения');
				return
			}

			//console.log('есть картинка',imageFile);
			let dt  = new DataTransfer();
			dt.items.add(new File([imageFile], imageFile.name || 'clipboard-image.png', {'type':imageFile.type}));
			document.querySelector('#uploadForm input[type="file"]').files = dt.files;
			let dmpEvent = {'target':{'files':dt.files}};
			let CmpReFileUpload = this.$children[0].$children[0]; // вот это опасное решение, т.к. структура может поменяться
			CmpReFileUpload.handlePreview(dmpEvent);
		},
		OnUploadFile(objData){
			//console.log('OnUploadFile', objData);
			this.bUploading=true;
			let objSendApi = {obj:'FileUpload',flt:{type:'notes_file'}};			
			this.$GVO.UploadFile(objData.formId,'UniUpload',objSendApi)
				.then(objApi => {  
					//console.log(objApi);
					if(objApi.success){
						this.fileUpload_model = objApi.data;						
										
					}else{
						alert(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
		},
		SET_STATUS(t_status){
			this.$GVO.ApiCall('TicketSystem.SET_STATUS',{flt:{ticket_id: this.$route.params.ticket_id, status:t_status},uData:{
				status:t_status,
				// sup_agent_id: this.$GVO.my_profile.code , 
				// sup_agent_name: this.$GVO.my_profile.fio,
			}}) 
			.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true){
						// this.getApiData();
						eventEmitter.$emit('t_status_changed', t_status);
						// this.status = t_status;
						// console.log(objApi);
					}else{
						alert('Не сохранилось. Возможно у вас нет прав на обработку заявки');
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});

		},
		cancelForm() {
			this.bIsPostForm = !this.bIsPostForm;
			this.fileUpload_model = '';
			this.strNote = '';
		},
		
	},
	mounted() {
		
	},
	created(){
		// eventEmitter.$on('reload_tasks', this.getLenta);
		eventEmitter.$on('reload_lenta', this.getLenta);
		this.getLenta();	
	},
	beforeDestroy() {
		// Отписываемся от события
		// eventEmitter.$off('reload_tasks', this.getLenta);
		eventEmitter.$off('reload_lenta', this.getLenta);
	},
}
</script>

<style scoped>
.overdue-text {color: #1d253b!important;}
/*============================ SEND NOTES ========================================*/
	.postAddForm-hide {
		display: none;
	}
	.postAddForm-show {
		display: block;
		margin-top: 15px;
	}
	.postForm {
		border: 1px solid transparent;
		border: 1px solid #01B0E0;
		border-radius: 0.2857rem;
		position: sticky;
		bottom: 0;		
	}
	.postForClick {padding: 15px 0px 0px 0px; cursor: pointer;}
	.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
	.cancel-note-btn {position: absolute;  top: 0; right: 0;}
	.clientPage .card-collapse .postForm {
		background: #27293d;
	}
	.white-content .card:not(.card-white) .postForm {
		background: #fff;
	}
	.postForm:hover, .focus-shadow  {
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	}
	.postForm h5 {
		margin-bottom: 0px;
	}
	.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
	.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
	.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

	.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
	.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
	.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
	.upload-file {display: flex; align-items: center;}
	.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

	.note-btn-group {position: relative;}
	.note-btn-row {position: absolute; top: 5px; right: 0;}

	.lenta-item.last .card-cinc {margin-bottom: 15px;}
	/*.BG-color-dark {background-color: #191f31!important;}
	.BG-color-light {background-color: #f1f6fc!important;}*/
	/* .StylesAuthor {border: 1px solid #00BF9A; background-color: #183d63;} */
	.white-content .card:not(.card-white) .StylesAuthor {background-color: #ebf3fb!important;} 
	/* .StylesRandom {border: 1px solid #9e77f3;} */
    
</style>
 